import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import { months_list } from "../../Shared/List"

const PayBranchPayrollForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [title, setTitle] = useState('')

    const [formData, setFormData] = useState({
        public_id: "",
        previous_balance: 0.00,
        transaction_fee: 0.00,
        payment_number: "",
        debit: 0.00,
        credit: 0.00,
        balance: 0.00,
        year: "",
        month: "",
    })
    const {public_id, transaction_fee, payment_number, previous_balance, debit, credit, balance, year, month} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state){
            const {payload} = location.state
            setFormData((prev) => ({
                ...prev,
                public_id: payload.public_id,
                year: payload.year,
                month: payload.month,
                debit: payload.debit,
                credit: payload.credit,
                balance: payload.balance,
                previous_balance: payload.previous_balance,
                transaction_fee: payload.transaction_fee,

            }))
            setTitle(`${months_list[payload.month - 1].name} - ${payload.year}, Payroll Payment Form`)
        }
    }, [])


    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }


    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {amount: balance, payment_number, year, month}
        payPayroll(payload)
    }
    
    // add payroll
    const payPayroll = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post(`/payrolls/credit/branch/${public_id}`, payload)
            toast.success(response.data?.detail)
            navigate('/')
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="previous_balance"
                                type="number"
                                label="Previous Balance"
                                disabled="disabled"
                                value={parseFloat(previous_balance)}
                                onChange={onChange}
                                error={errors.previous_balance}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="debit"
                                type="number"
                                label="Debit"
                                disabled="disabled"
                                value={parseFloat(debit)}
                                onChange={onChange}
                                error={errors.debit}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="transaction_fee"
                                type="number"
                                label="Transaction Fee"
                                disabled="disabled"
                                value={parseFloat(transaction_fee)}
                                onChange={onChange}
                                error={errors.transaction_fee}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="credit"
                                type="number"
                                label="Credit"
                                disabled="disabled"
                                value={parseFloat(credit)}
                                onChange={onChange}
                                error={errors.credit}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="balance"
                                type="number"
                                label="Balance"
                                disabled="disabled"
                                value={parseFloat(balance)}
                                onChange={onChange}
                                error={errors.balance}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                placeholder="252618304530"
                                name="payment_number"
                                type="number"
                                label="Payment Number"
                                value={payment_number}
                                onChange={onChange}
                                error={errors.payment_number}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Process Payment" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default PayBranchPayrollForm